import "./TreeViewStyle.scss";
var TreeViewComponent = /** @class */ (function () {
    function TreeViewComponent(options) {
        this.options = options;
    }
    TreeViewComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    TreeViewComponent.prototype.render = function () {
        var _a, _b;
        return {
            tag: "div", attr: { style: this.options.style, class: "treeview-comp hover " + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "") }, children: [
                { tag: "ul", attr: { class: "tv-ul" }, children: [this.renderNode((_b = this.filteredData) !== null && _b !== void 0 ? _b : this.options.data)] }
            ]
        };
    };
    TreeViewComponent.prototype.renderNode = function (el) {
        var _this = this;
        function getInput() {
            var res = { tag: "input", attr: { class: "tv-input", type: "checkbox", id: el.id } };
            if (el.collapsed) {
                res.attr.checked = "checked";
            }
            return res;
        }
        return (el.children && el.children.length > 0) ?
            { tag: "li", children: [
                    getInput(),
                    this.addChild({ tag: "label", attr: { for: el.id } }, this.options.renderItem != null ? this.options.renderItem(el) : el.content),
                    { tag: "ul", attr: { class: "tv-ul" }, children: el.children.map(function (c) { return _this.renderNode(c); }) }
                ] } :
            this.addChild({ tag: "li" }, this.options.renderItem != null ? this.options.renderItem(el) : el.content);
    };
    TreeViewComponent.prototype.addChild = function (parent, content) {
        if (typeof content === "string") {
            parent.content = content;
        }
        else {
            parent.children = [content];
        }
        return parent;
    };
    return TreeViewComponent;
}());
export { TreeViewComponent };
